import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// ========== SCSS ==========
import '../scss/navbar.scss';

// ========== ASSETS ==========
import logo from '../_assets/images/logo.png';
import add_user from '../_assets/images/icons/add_user.svg';

export class NavBar extends Component {
  constructor(props) {
    super(props);
  }

  getMenuItems() {
    if (window.utils.logged) {

      return [
        {
          title: 'Estados',
          url: '/states',
          external: false
        },
        {
          title: 'Monitoramento e Informações',
          url: '/monitoring',
          external: false
        },
        {
          title: 'Banco de ideias',
          url: '/directory/2',
          external: false
        },
        {
          title: 'Agendas do projeto',
          url: '/schedule',
          external: false
        },
        {
          title: 'Grupo Executivo',
          url: '/directory/3',
          external: false
        }
      ];

    } else {

      return [
        {
          title: 'Home',
          url: 'https://' + window.location.hostname,
          external: true
        },
        {
          title: 'Quem Somos',
          url: 'https://' + window.location.hostname + '/quem-somos/',
          external: true
        },
        {
          title: 'Publicações',
          url: 'https://' + window.location.hostname + '/publicacoes/',
          external: true
        },
        {
          title: 'Notícias',
          url: 'https://' + window.location.hostname + '/category/noticias/',
          external: true
        },
        {
          title: 'Galeria',
          url: 'https://' + window.location.hostname + '/category/galeria/',
          external: true
        },
        {
          title: 'Acesso Restrito',
          url: 'https://' + window.location.hostname + '/area-restrita/',
          external: true
        }
      ];

    }
  }

  logout() {
    if (window.confirm('Tem certeza?')) {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('is_admin');
      window.location = '/home';
    }
  }

  render() {
    return (
      <header>
        <div className="container">
          <img className="logo" src={logo} />
          <button id="mobileBtn" onClick={(e) => {
              document.querySelector('header nav').classList.toggle('active');
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-bars" />
          </button>
          <nav className={window.utils.logged ? 'logged' : ''}>
            <ul>
              {this.getMenuItems().map(( item, index ) => {
                return(
                  <li key={index}>
                    {
                      item.external
                        ? <a className="nav-links" href={item.url}>
                            { item.title }
                          </a>
                        : <Link className="nav-links" to={item.url}>
                            { item.title }
                          </Link>
                    }
                  </li>
                );
              })}
            </ul>
            <div className="nav-controllers">
              {
                window.utils.logged
                  ? <Link to="/reset" id="resetPassword">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M80 192V144C80 64.47 144.5 0 224 0C303.5 0 368 64.47 368 144V192H384C419.3 192 448 220.7 448 256V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V256C0 220.7 28.65 192 64 192H80zM144 192H304V144C304 99.82 268.2 64 224 64C179.8 64 144 99.82 144 144V192z"/></svg>
                      Senha
                    </Link>
                  : null
              }
              {
                (sessionStorage.getItem('is_admin') == true || sessionStorage.getItem('is_admin') == 'true')
                  ? <Link to="/list/user" id="userListBtn">
                      <img src={add_user} />
                      Usuários
                    </Link>
                  : null
              }
              {
                window.utils.logged
                  ? <button id="logoutBtn" onClick={(e) => {this.logout()}}>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">{/*! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. */}<path d="M160 416H96c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h64c17.67 0 32-14.33 32-32S177.7 32 160 32H96C42.98 32 0 74.98 0 128v256c0 53.02 42.98 96 96 96h64c17.67 0 32-14.33 32-32S177.7 416 160 416zM502.6 233.4l-128-128c-12.51-12.51-32.76-12.49-45.25 0c-12.5 12.5-12.5 32.75 0 45.25L402.8 224H192C174.3 224 160 238.3 160 256s14.31 32 32 32h210.8l-73.38 73.38c-12.5 12.5-12.5 32.75 0 45.25s32.75 12.5 45.25 0l128-128C515.1 266.1 515.1 245.9 502.6 233.4z" /></svg>
                      Sair
                    </button>
                  : null
              }
            </div>
          </nav>
        </div>
      </header>
    );
  }
}

export default NavBar
